import api from './AxiosInstance';

export class FamilleService {
 

  searchBeneciaire = async (payload) => {
    try {
      const response = await api.post(`/Benef/Search/List`, payload,{
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
     
      throw error; 
    }
  };
  getAllFamille = async () => {
    try {
      const response = await api.get(`/Benef/list`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
      throw error; 
    }
  };

  getAllBeneficiaire = async () => {
    try {
      const response = await api.get(`/Benef/typeBenef/list`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
      throw error; 
    }
  };

  
  deleteBenefs= async (matribenef) => {
    try {
    
      const response = await api.delete(`/Benef/delete/${matribenef}/IPM`) 

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de prestation :', error);
      throw error;
    }
  };

  getAllBeneciaire = async (matripart) => {
    try {
      const response = await api.get(`/Benef/list/${matripart}`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
     
      throw error; 
    }
  };
 
  updateListFournis= async ( updatedFournisseur) => {
    try {
     

      const response = await api.put(`/Fournisseur/update`, updatedFournisseur)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de prestation :', error);
      throw error;
    }
  };


  addListFournis= async ( newPrestation) => {
    try {
    
  
      const response = await api.post(`/Benef/typeBenef/add`, newPrestation )
      
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);

      throw error;
    }
  };


  deleteListFournis= async ( prestationId) => {
    try {
    
      const response = await api.delete(`/Benef/typeBenef/delete/${prestationId}`) 

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de prestation :', error);
      throw error;
    }
  };

addBenef= async ( payload) => {
  try {
  

    const response = await api.post(`/Benef/add`, payload )
    
    return response.data;
  } catch (error) {
    console.error('Erreur lors de l\'ajout de prestation :', error);

    throw error;
  }
};

updateBenef= async ( payload) => {
  try {
   

    const response = await api.put(`/Benef/update`, payload)

    return response.data;
  } catch (error) {
    console.error('Erreur lors de la mise à jour de prestation :', error);
    throw error;
  }
};

}


